import { END_POINTS } from "../helpers";
import { Article, SupportTicket, VideoItem } from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const mainApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query<CommonResponse, {}>({
      query: () => ({
        url: END_POINTS.category,
        method: "GET",
      }),
    }),
    getKnowledgeBase: builder.query<
      CommonResponse & { data: { list: Article[]; total: number } },
      { page?: number; limit?: number; search?: string }
    >({
      query: (params) => ({
        url: END_POINTS.knowledgeBase,
        method: "GET",
        params,
      }),
    }),

    getTutorial: builder.query<
      CommonResponse & { data: { list: VideoItem[] } },
      {}
    >({
      query: () => ({
        url: END_POINTS.tutorial,
        method: "GET",
      }),
    }),

    getKnowledgeResources: builder.query<
      CommonResponse & { data: any },
      number | string
    >({
      query: (id) => `${END_POINTS.knowledgeById}/${id}`,
    }),

    getTutorialResources: builder.query<
      CommonResponse & { data: any },
      number | string
    >({
      query: (id) => `${END_POINTS.tutorialById}/${id}`,
    }),

    getTickets: builder.query<
      CommonResponse & { data: { list: SupportTicket[]; total: number } },
      { page?: number; limit?: number; search?: string; status?: number; priority?: string | number }
    >({
      query: (params) => ({
        url: END_POINTS.tickets,
        method: "GET",
        params,
      }),
      providesTags: ["TICKETS"],
    }),

    createTicket: builder.mutation<
      CommonResponse & { data: any },
      { body: any }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.tickets}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["TICKETS", "TICKET_STATS"],
    }),
    getTicketsStats: builder.query<CommonResponse, void>({
      query: () => ({
        url: `${END_POINTS.ticketsStats}`,
        method: "GET",
      }),
      providesTags: ["TICKET_STATS"],
    }),
    getFaqs: builder.query<CommonResponse, void>({
      query: () => ({
        url: `${END_POINTS.faqListing}`,
        method: "GET",
      }),
    }),
    getCms: builder.query<CommonResponse, any>({
      query: (params) => ({
        url: END_POINTS.cms,
        method: "GET",
        params,
      }),
    }),
    deleteTicket: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.tickets}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["TICKETS", "TICKET_STATS"],
    }),
    toggleKnowledgeLike: builder.mutation<CommonResponse, number | string>({
      query: (id) => ({
        url: `${END_POINTS.knowledgeLike}/${id}`,
        method: "POST",
      }),
    }),
    toggleTutorialLike: builder.mutation<CommonResponse, number | string>({
      query: (id) => ({
        url: `${END_POINTS.tutorialLike}/${id}`,
        method: "POST",
      }),
    }),
  }),
});

export const { useLazyGetCategoryQuery,
  useGetKnowledgeBaseQuery,
  useGetTutorialQuery,
  useGetKnowledgeResourcesQuery,
  useGetTutorialResourcesQuery,
  useGetTicketsQuery,
  useCreateTicketMutation,
  useGetTicketsStatsQuery,
  useGetFaqsQuery,
  useLazyGetCmsQuery,
  useDeleteTicketMutation,
  useToggleKnowledgeLikeMutation,
  useToggleTutorialLikeMutation, } = mainApi;
